import React, { useState, useEffect, useRef } from "react";
import "./Models.css";
import {
  Badge,
  Dropdown,
  DropdownItem,
  Form,
} from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  handleNewConversationRequest,
  setCanSetActiveModels,
  setChat1Data,
  setChat2Data,
  setChat3Data,
  setChat4Data,
  setChat5Data,
  setChat6Data,
  setMaximizedChat,
  setShowPlansModal,
  setShowSignPopup,
} from "../../../../store/one-query/chatsSlice";
import {
  useIsAllowedVersion,
} from "../../../../store/Apis/ConversationVersionsApi";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import { useNavigate } from "react-router-dom";
import { Box, Tooltip } from "@mui/material";
import ProIcon from "../../../../Custom-imeges/ProIcon";
interface Version {
  id: string;
  name: string;
  createdAt: string;
  updatedById: string;
  updatedAt: string;
  createdById: string;
  isDeleted: boolean;
  deletedById: string;
  deletedAt: string;
  title: string;
  version: string;
  allowAnnonymous: boolean;
  isPro: boolean;
}
interface ModelsProps {
  modelName: string;
  companyName: string;
  defaultNameVersion: string | undefined;
  index: number;
  page: string;
  setVersionModel: (id: string) => void;
  annonyVersion: string | undefined;
  lastActiveVersion?: any;
}

const ReturnVersionModel = (props: ModelsProps) => {
  const {
    modelName,
    companyName,
    defaultNameVersion,
    index,
    page,
    setVersionModel,
    lastActiveVersion,
    annonyVersion,
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [versionArrayData, setVersionArrayData] = useState<Version[]>();
  const [version, setVersion] = useState<string>("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const conversationVersionModels = useAppSelector(
    (state) => state.conversationVersion.data
  );
  const versionIsAllowedMutate = useIsAllowedVersion();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const disabledVersions = useAppSelector((s) => s.ChatsState.disabledVersions);
  const [defaultVersion, setDefaultVersion] = useState<any>();
  const [search , setSearch] = useState("");
  const versionsInputRef = useRef<HTMLInputElement>(null);
  const User = useAppSelector((s) => s.User);
  const ChatsState = useAppSelector((s) => s.ChatsState);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    setDefaultVersion(
      !User.IsAuthenticated
        ? conversationVersionModels?.find(
            (version) => version.id === annonyVersion && version.allowAnnonymous
          )
        : conversationVersionModels?.find(
            (version) => version.id === defaultNameVersion
          )
    );
  }, [annonyVersion, defaultNameVersion]);

  useEffect(() => {
      if (defaultVersion) {
      setVersion(defaultVersion.title);
        handleSelectedVersion(
          defaultVersion.title,
          defaultVersion.id,
          defaultVersion.version,
          defaultVersion.allowAnnonymous,
          defaultVersion.name,
          defaultVersion.isPro
        );
      }
  }, [defaultVersion, handleNewConversationRequest]);

  useEffect(() => {
      if (defaultVersion && ChatsState.newConversation) {
      setVersion(defaultVersion.title);
        handleSelectedVersion(
          defaultVersion.title,
          defaultVersion.id,
          defaultVersion.version,
          defaultVersion.allowAnnonymous,
          defaultVersion.name,
          defaultVersion.isPro
        );
    }
  }, [ChatsState.newConversation]);

  useEffect(() => {
    if (conversationVersionModels) {
      setVersionArrayData(conversationVersionModels);
    }
  }, [conversationVersionModels, versionArrayData]);


  useEffect(() => {
    if (lastActiveVersion && versionArrayData) {
      const versionObj = versionArrayData.find(
        (obj) => obj.id === lastActiveVersion.id
      );
      if (versionObj) {
        handleSelectedVersion(
          versionObj.title,
          versionObj.id,
          versionObj.version,
          versionObj.allowAnnonymous,
          versionObj.name,
          versionObj.isPro
        );
      }
    }
  }, [lastActiveVersion, versionArrayData]);

  const handleSetIdForEveryChat = (title = "", id = "", version = "" , name = "") => {
    const chatData = { id, version , name};

    switch (index) { 
      case 0:
        dispatch(setChat1Data(chatData));
        break;
      case 1:
        dispatch(setChat2Data(chatData));
        break;
      case 2:
        dispatch(setChat3Data(chatData));
        break;
      case 3:
        dispatch(setChat4Data(chatData));
        break;
      case 4:
        dispatch(setChat5Data(chatData));
        break;
      case 5:
        dispatch(setChat6Data(chatData));
        break;
      default:
        break;
    }
    setVersionModel(version);
    setVersion(title);
    setDropdownOpen(false);
  };

  const handleSelectedVersion = (
    title: string,
    id: string,
    version: string,
    versionIsAnnony: boolean,
    name:string,
    isPro:boolean
  ) => {
    if(!User.IsAuthenticated){
      if (versionIsAnnony) {
          handleSetIdForEveryChat(title, id, version, name);  
      } else {
        dispatch(setShowSignPopup({show: true , type: companyName , message: "To unlock this Model you need to Sign in."
          ,btnTitle:'Sign In for Free', btnAction:"NavigateToLogin"}))
      }
    } else {
      if (isPro && !User.isSubscribed){
        dispatch(setShowPlansModal(true))
      }
      else {
        handleSetIdForEveryChat(title, id, version, name);
      }
    }
  };

  const handleSelectVersionClick = (
    title: string,
    id: string,
    version: string,
    versionIsAnnony: boolean,
    name:string,
    isPro:boolean
  ) => {
    dispatch(setCanSetActiveModels(true));
    handleSelectedVersion(title,id,version,versionIsAnnony,name,isPro)
    if (ChatsState.fullWidthMode?.length){
      dispatch(setMaximizedChat({ versionId: id, versionName: version }));
    
    setSearch("")
    if(versionsInputRef.current){
      versionsInputRef.current.value = ""
    }
  };}

  const handleSelectVersion = () => {
    dispatch(conversationsActions.setIsConHistoryClicked(false));
  };

  const handleClose = () => {
    dispatch(setShowPlansModal(false))
  };
  
 const handleClickOutside = (event: MouseEvent) => {
   if (
     dropdownRef.current &&
     !dropdownRef.current.contains(event.target as Node)
   ) {
     setDropdownOpen(false);
   }
 };

  useEffect(() => {
    setSearch("")
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <>
      <Dropdown
        className="model-versions"
        show={dropdownOpen}
        ref={dropdownRef}
      >
        <Dropdown.Toggle className="versions" onClick={handleSelectVersion}>
          {dropdownOpen ?
            (<div className="w-100 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center w-100">
                <label htmlFor="input" className="c-pointer">
                  <img src="/images/GetConversations/search-normal.svg" className="me-1" />
                </label>
                <Form.Control
                  ref={versionsInputRef}
                  className="versions-search-input border-0 bg-transparent p-0 m-0"
                  placeholder="Versions"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="versions-arrow" onClick={toggleDropdown}>
                  <ArrowUpIcon className="return-versions-arrow"/>
              </div>
            </div>) 
           :
            (<div
            className="d-flex align-items-center justify-content-between"
            onClick={toggleDropdown}
          >
            <span className={dropdownOpen ? "opened" : ""}>
              {version}
            </span>
            <ArrowDown className="return-versions-arrow"/>
          </div>)
          }
        </Dropdown.Toggle>
        <Dropdown.Menu className="versions-menu">
          {modelName &&
            versionArrayData
              ?.filter((version) => {
                return search !== ""
                  ? version.title
                      ?.trim()
                      .toLowerCase()
                      .includes(search.trim().toLowerCase())
                  : version;
              })
              .map((obj, index) => {
                if (obj.name.toLowerCase() === modelName) {
                  const isDisabled = disabledVersions.includes(obj.id)
                    ? true
                    : false;
                  return (
                    <Tooltip
                      title={obj.title}
                      placement="bottom"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "var(--A_background73)",
                            color: "var(--A_font-color48)",
                            padding: "0.3rem 0.8rem",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "var(--A_background73)",
                          },
                        },
                      }}
                    >
                      <DropdownItem
                        disabled={isDisabled}
                        key={index}
                        className={`version-item  ${
                          !obj.allowAnnonymous ? "disabled-hover" : ""
                        } ${version === obj.title && "selected"}
                        ${!User.IsAuthenticated ? "Landing-page" : ""}`}
                        onClick={() => {
                          handleSelectVersionClick(
                            obj.title,
                            obj.id,
                            obj.version,
                            obj.allowAnnonymous,
                            obj.name,
                            obj.isPro
                          );
                        }}
                      >
                        <span className={`version-name ${page}`}>
                          {obj.title}
                        </span>

                        {!User.IsAuthenticated && !obj.allowAnnonymous ? (
                          <Badge className="bg-transparent">
                            <img src="/images/Lock-light.svg" />
                          </Badge>
                        ) : (
                          obj.isPro &&
                          !User.isSubscribed && (
                            <Box className="main-page-pro">
                              <ProIcon className="custom-Pro-Icon"/>
                            </Box>

                          )
                        )}
                      </DropdownItem>
                    </Tooltip>
                  );
                }
                return null;
              })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default ReturnVersionModel;
